import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import Image from "../Image";

var Avatar = function Avatar(_ref) {
  var alt = _ref.alt,
      fillColor = _ref.fillColor,
      sizes = _ref.sizes,
      src = _ref.src,
      srcSet = _ref.srcSet,
      width = _ref.width;
  var getClassName = getClassNameFactory(Avatar.displayName);
  var divProps = {
    className: getClassName()
  };

  if (width) {
    divProps.style = {
      maxHeight: "".concat(width, "px"),
      width: "".concat(width, "px")
    };
  }

  return /*#__PURE__*/React.createElement("div", divProps, /*#__PURE__*/React.createElement(Image, {
    alt: alt,
    fillColor: fillColor,
    fit: "cover",
    sizes: sizes,
    src: src,
    srcSet: srcSet
  }));
};

Avatar.displayName = "Avatar";
export default Avatar;